import { Injectable } from '@angular/core';

import { BreadcrumbItem } from '@mitsubishi/shared/ui';

import { Action, State, StateContext } from '@ngxs/store';

import { SetBreadcrumbs } from './breadcrumbs.actions';
import { PROJECT_BREADCRUMBS_STATE_TOKEN } from './breadcrumbs.model';

@State<BreadcrumbItem[]>({
  name: PROJECT_BREADCRUMBS_STATE_TOKEN,
  defaults: [],
})
@Injectable()
export class ProjectBreadcrumbsState {
  @Action(SetBreadcrumbs)
  setBreadcrumbs(ctx: StateContext<BreadcrumbItem[]>, { breadcrumbs }: SetBreadcrumbs) {
    ctx.setState(breadcrumbs);
  }
}
